import { useLingui } from '@lingui/react/macro';
import { useCallback } from 'react';
import { BaseDialog, type DialogKey, useDialogStore } from '@/components/dialogs';
import { DepositPanel } from './components/deposit_panel.tsx';

const DIALOG_KEY: DialogKey = 'depositCollateralDialog';

export function DepositCollateralDialog() {
  const { t } = useLingui();
  const isOpen = useDialogStore((state) => state.isDialogOpen(DIALOG_KEY));
  const close = useDialogStore((state) => state.closeDialog);

  const handleClose = useCallback(() => {
    close(DIALOG_KEY);
  }, [close]);

  return (
    <BaseDialog
      dialogKey={DIALOG_KEY}
      title={t({ comment: 'Deposit dialog title', message: 'Deposit' })}
      onClose={handleClose}
      dialogProps={{ disableEnforceFocus: true }}
    >
      <DepositPanel isActive={isOpen} onClose={handleClose} />
    </BaseDialog>
  );
}
